import StyleSheet from 'styles'
export default StyleSheet({
  section: {
    marginBottom: 50,
    position: 'relative',
    '@media print': {
      marginBottom: 20,
    }
  },
  note: {
    color: '#6AAEAA',
    fontSize: '12px',
    fontWeight: 'bold',
    paddingLeft: '0.5em',
    '&$disabled': {
      color: '#1B3044'
    }
  },
  checkbox: {
    display: 'inline-block',
    marginLeft: -14,
    marginRight: 14,
    paddingRight: 10,
    boxSizing: 'border-box',
  },
  textCheckbox: {
    marginLeft: -8,
    marginRight: -7,
  },
  alignedColumns: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    '& > li': {
      '& > span': {
        marginRight: 0,
      },
      minWidth: '33.3333333%',
      paddingRight: 0,
      '@media(max-width: 600px)': {
        minWidth: '50%',
      }
    }
  },
  addButton: {
    backgroundColor: '#b9b39b',
    color: 'white',
    marginBottom: 20,
    '&:hover': {
      backgroundColor: '#c2bca4',
    }
  },
  titleBlock: {
    '& h5': {
      paddingBottom: 5
    },
    '& h6': {
      paddingTop: 5,
      paddingBottom: 50
    },
  },
  headerRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    '& button': {
      alignSelf: 'center',
      marginTop: -10,
    },
  },
  nestedHeading: {
    position: 'relative',
    top: '-50px'
  },
  itemDelete: {
    position: 'absolute',
    right: 0,
  },
  sectionDelete: {
    float: 'right',
    marginTop: -42,
  },
  partnerLogo: {
    paddingBottom: 10,
    position: 'relative',
    '& $itemDelete': {
      top: 0
    }
  },
  galleryImage: {
    padding: [4, 48, 10, 0],
    position: 'relative',
    '& $itemDelete': {
      top: 0
    }
  },
  composite: {
    width: '50%',
    display: 'inline-block',
    boxSizing: 'border-box',
    verticalAlign: 'top',
    paddingRight: 10,
    '@media(max-width: 626px)': {
      width: '100%',
      paddingRight: 0,
    },
    '&$bonus': {
      width: '35%',
      paddingTop: 3,
      '@media(max-width: 626px)': {
        width: '100%',
        paddingRight: 0,
      }
    },
    '&$date': {
      width: '65%',
      '@media(max-width: 626px)': {
        width: '100%',
        paddingRight: 0,
      }
    }
  },
  bonus: {},
  date: {} ,
  disabled: {},
  linkButton: {
    'button&': {
      color: '#6AAEAA',
      float: 'right',
      padding: 10,
      fontWeight: 'bold',
      textDecoration: 'none',
    }
  }
})